import { render, staticRenderFns } from "./bundle.vue?vue&type=template&id=4c4bda0a&scoped=true"
import script from "./bundle.vue?vue&type=script&lang=js"
export * from "./bundle.vue?vue&type=script&lang=js"
import style0 from "./bundle.vue?vue&type=style&index=0&id=4c4bda0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4bda0a",
  null
  
)

export default component.exports